import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        checkbox: {
            padding: '0px !important',
        },
        inputLabel: {
            display: 'none',
        },
        enumInput: {
            '& .MuiTypography-root': {
                padding: '0px !important',
            },
        },
        tableCellHead: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
        },
        link: {
            paddingBottom: 0,
        },
        productTypesInput: {
            minWidth: 200,
        },
    }
})

export default useStyles
